import Button from "../ui/Button/Button.jsx";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import TheTouchingHands from "../../Assets/Images/Abstract Head.jpg";
import { useRef } from "react";
import { MdArrowOutward } from "react-icons/md";

export default function FirstSection({ finalSectionRef }) {
  const scrollToFinalSection = () => {
    if (finalSectionRef.current) {
      finalSectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="w-full py-12 md:py-24 lg:py-32 xl:py-56 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10 flex justify-end items-center">
        <img
          src={TheTouchingHands}
          className="w-full h-full object-cover"
          alt="The Gifting Lady"
        />
      </div>
      <div className="container px-4 md:px-6 relative">
        <div className="flex flex-col items-center space-y-4 text-center">
          <div className="space-y-2">
            {/* Animated Title */}
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              className="font-open-sans text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl lg:text-6xl/none bg-clip-text text-transparent bg-gradient-to-r from-red-600 via-orange-600 to-red-600"
            >
              Advancing the Frontiers of AI Research
            </motion.h1>

            {/* Animated Paragraph (Appears after Title) */}
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
              className="mx-auto max-w-[700px] text-gray-700 md:text-xl dark:text-neutral-green-400"
            >
              Exploring open-source models and pushing the boundaries of
              artificial intelligence to shape the future of technology.
            </motion.p>
          </div>
          <div className="space-x-4">
            <Link to="/magic">
              <Button
                variant="outline"
                size="md"
                rounded="3xl"
                rightIcon={<MdArrowOutward size={19} />}
                className="border-red-600 text-red-600 hover:bg-red-500 hover:text-grey-100"
              >
                Try it on Hugging Face
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
